
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/your-content/promoted-at-your-district",
      function () {
        return require("private-next-pages/your-content/promoted-at-your-district/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/your-content/promoted-at-your-district"])
      });
    }
  